
import {Component} from 'vue-property-decorator';
import LastSync from '@/components/LastSync.vue';
import BaseReport from '../../BaseReport.vue';
import userx from '@/store/modules/userx';
import router from '@/router';
import StickyFilterContainer from '@/components/reports-v3/components/pages/StickyFilterContainer.vue';
import DateFilter from '@/components/reports-v3/components/filters/DateFilter.vue';
import DateRangeFilter from '@/components/reports-v3/components/filters/DateRangeFilter.vue';
import InstafreshDashboard from '@/components/reports-v3/components/codedWidgets/custom/instafresh/InstafreshDashboard.vue';
import TongYuenSalesOverview from '@/components/reports-v3/components/codedWidgets/custom/tongyuen/TongYuenSalesOverview.vue';
import moment from 'moment';
import gdbx from '@/store/modules/gdbx';
import accountx from '@/store/modules/accountx';
import VivalecDashboard from '@/components/reports-v3/components/codedWidgets/custom/vivalec/VivalecDashboard.vue';
import PalmKingDashboard from '@/components/reports-v3/components/codedWidgets/custom/palmking/PalmKingDashboard.vue';
import TiarcoChemicalM from '@/components/reports-v3/components/codedWidgets/custom/tiarco/TiarcoChemicalM.vue';
import ProjectFilter from '@/components/reports-v3/components/filters/ProjectSelectFilter.vue';
import NonStopAutoDashboard from '@/components/reports-v3/components/codedWidgets/custom/nonstopauto/NonStopAutoDashboard.vue';
import BICustomerRenewalDashboard from '@/components/reports-v3/components/codedWidgets/custom/_internal/BICustomerRenewalDashboard.vue';
import NYCXCustomDashboard from '@/components/reports-v3/components/codedWidgets/custom/nycx/NYCXCustomDashboard.vue';
/* tslint:disable-next-line:max-line-length */
import StarfieldDashboard from '@/components/reports-v3/components/codedWidgets/custom/starfield/StarfieldDashboard.vue';
/* tslint:disable-next-line:max-line-length */
import KimChokSdnBhdDashboard from '@/components/reports-v3/components/codedWidgets/custom/kim-chok-sdn-bhd/KimChokSdnBhdDashboard.vue';
import GeneralListFilter from '@/components/reports-v3/components/filters/GeneralListFilter.vue';
import StockGroupListFilter from '@/components/reports-v3/components/filters/StockGroupListFilter.vue';
import CustomerListFilter from '@/components/reports-v3/components/filters/CustomerListFilter.vue';
import { ValueText } from '@/store/models.def';
import dbw from '@/worker/dbw';

@Component({
    components: {
        KimChokSdnBhdDashboard,
        GeneralListFilter,
        StockGroupListFilter,
        CustomerListFilter,
        StarfieldDashboard,
        NYCXCustomDashboard,
        BICustomerRenewalDashboard,
        NonStopAutoDashboard,
        ProjectFilter,
        TiarcoChemicalM,
        VivalecDashboard,
        PalmKingDashboard,
        TongYuenSalesOverview,
        LastSync,
        InstafreshDashboard,
        StickyFilterContainer,
        DateFilter,
        DateRangeFilter,
    },
})
export default class MyFavorite extends BaseReport {
    public id: any = '';
    public selectedDay: number = moment().endOf('day').valueOf();
    public selectedProjects = [];
    public selectedLocations = [];
    public selectedStockGroups = [];
    public selectedUdfGroups = [];
    public selectedCustomerList = [];
    // Distinct UDF_GROUP values for the Group filter (DIY field, no gdbx source);
    // loaded from the diySalesIvCsDnCn card in mounted(). Value = label.
    public udfGroupOptions: ValueText[] = [];
    public customisedPages = [
        'dtcAG2NueCD2BKoGvTgr', 'IZKrbHk6vsPoXEViNrAd', 'NgR7bwRLm1kN61HSt8l7', 'Fzwxxr8qz7yrY4MiuUT3', 'xZNyNfWKwAofOKLloHyc', 'B2PxHqrl6o0SuSeNdix6', 'icG5nKlHrlmZbSfdRAEa', '8mDIPRIiODPsDy16YbCD', 'BINpg03skWgN94kjwyOm', 'dgHU51v0NnYfbeF26Knr',
    ];

    public manualDateRange: [number, number] = [
        moment().add(0, 'month').startOf('month').valueOf(),
        moment().valueOf(),
    ];

    public selectedCurrentMonth = moment().endOf('month').valueOf();

    public get selectedCurrentMonthRange(): [number, number] {
        return [
            moment(this.selectedDay).subtract(12, 'months').startOf('month').valueOf(),
            moment(this.selectedDay).endOf('month').valueOf(),
        ];
    }

    public get selectedDateRange() {
        return [
            moment(this.selectedDay).startOf('month').valueOf(),
            moment(this.selectedDay).endOf('day').valueOf(),
        ];
    }

    public get selectedAgents(): string[] {
        return gdbx.allAgents.map((item) => item.value);
    }

    public get selectedCustomers(): string[] {
        return gdbx.allCustomers.map((item) => item.value);
    }

    // Detail Location options (system field: code + description).
    public get allLocations(): ValueText[] {
        return gdbx.allLocations;
    }

    // The Group filter's full value set, passed to the widget so it can tell
    // "all groups selected" from "some selected".
    public get udfGroupValues(): string[] {
        return this.udfGroupOptions.map((o) => o.value);
    }

    public get selectedAsOfDate() {
        return moment(this.selectedDay).endOf('day').valueOf();
    }

    public async mounted() {
        this.id = accountx.currentAccountId;
        this.track();

        // KIM CHOK SDN BHD mockup — default to the last 12 months so the
        // Monthly view shows a full trend on first load.
        if (accountx.currentAccountId === 'dgHU51v0NnYfbeF26Knr') {
            this.manualDateRange = [
                moment().subtract(11, 'month').startOf('month').valueOf(),
                moment().endOf('day').valueOf(),
            ];

            // UDF_GROUP is a DIY field with no gdbx source, so load its distinct
            // values from the card itself to populate the Group filter. Value =
            // label (the field is self-describing).
            try {
                const head = await dbw.loadTable('diySalesIvCsDnCn');
                const groups = await head.rawQuery(`
                    SELECT DISTINCT "UDF_GROUP" as g
                    FROM {table}
                    WHERE "UDF_GROUP" IS NOT NULL
                    ORDER BY g
                `);
                this.udfGroupOptions = groups
                    .map((r: any) => String(r.g))
                    .filter((g: string) => g !== '')
                    .map((g: string) => ({ value: g, text: g }));
            } catch (e) {
                // Table not available for this account/session — leave the Group
                // filter empty (it simply won't constrain the charts).
            }
        }

        if (accountx.currentAccountId === 'HsJ2Zj1jFkQVkxOKmxvk') {
            await this.$router.push('/account/' + accountx.currentAccountId + '/dealer');
        }

        if (accountx.currentAccountId === 'BINpg03skWgN94kjwyOm') {
            const head = await dbw.loadTable('diyCurrentFinancialPeriod');
            const result = await head.rawQuery(`
                SELECT TRY_CAST("STARTDATE" AS DOUBLE) as "startDate",
                    TRY_CAST("ENDDATE" AS DOUBLE) as "endDate"
                FROM {table}
                LIMIT 1
            `);
            if (result[0]) {
                this.manualDateRange = [
                    Number(result[0].startDate),
                    Number(result[0].endDate),
                ];
            }
        }
    }

    public track() {
        this.$ga.set('userId', userx.user!.uid + '_' + userx.user!.email);
        this.$ga.page(router);
    }
}
